// extracted by mini-css-extract-plugin
export default {"container":"river-spinner_container__Rb4FY"};